// extracted by mini-css-extract-plugin
module.exports = {"titleCard":"head_titleCard__24otW","headTags":"head_headTags__3X1FN","headSlider":"head_headSlider__4gEBY"};